import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useState, useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";

const OWNER_TENANT_ID = "81dcdb1a-7b62-4ad6-a9d5-0f94d2f2b6cf";

export function useIsAdmin(): boolean {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (inProgress !== InteractionStatus.None) {
            return;
        }

        if (!isAuthenticated) {
            setIsAdmin(false);
            return;
        }

        const account = instance.getActiveAccount();
        if (!account) {
            setIsAdmin(false);
            return;
        }

        const tenantId = account.tenantId;

        if (tenantId !== OWNER_TENANT_ID) {
            setIsAdmin(false);
            return;
        }

        // Read roles directly from ID token (this is what worked before!)
        const roles = (account.idTokenClaims?.roles as string[] | undefined) || [];
        const hasRole = roles.includes("AcademyManager");

        setIsAdmin(hasRole);
    }, [instance, isAuthenticated, inProgress]);

    return isAdmin;
}
